module.exports = __webpack_public_path__ + "img/zorn.c06cc5a8.png";